import { Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PageHeader from "../../components/UI/Headers/PageHeader/PageHeader";
import CustomTabs from "../../components/UI/Tabs/CustomTabs/CustomTabs";
import { TabItemEntity } from "../../entities/UIEntities/TabItem";
import { ROLES_HIERARCHY, USER_TYPES, TABLES } from "../../enums/Enums";
import useAllocationService from "../../hooks/useAllocationService";
import { userActions } from "../../redux/reducers/UserReducer";
import store from "../../redux/Store";
import Strings from "../../resources/Strings";
import classes from "../Allocations/AllocationsPage.module.css";
import Icons from "../../resources/icons/Icons";
import { commonActions } from "../../redux/reducers/CommonReducer";
import AllocationInfo from "../UserInfo/SideWindowInfo/AllocationInfo";
import AddAllocationsForm from "../../components/UI/Forms/Wizard Forms/AddForms/AddAllocationsForm";
import { allocationsActions } from "../../redux/reducers/AllocationsReducer";

const AllocationsPage = () => {
  const allocations = useSelector((state) => state.allocations.allocations);
  const currentUsersSite = useSelector((state) => state.user.currentUsersSite);

  const gmtUser = useSelector((state) => state.user.gmtUser);
  const [tableId, setTableId] = useState(TABLES.OCCUPIED);
  let tabs = [];
  const showUserInfoWindow = useSelector((state) => {
    return state.user?.showUserInfoWindow;
  });

  const selectionModel = useSelector((state) => state.allocations.allocationSelectionModel); 
  const { getOccupiedDataTable } = useAllocationService();

  const onRowClick = (tableId, selectionModel) => {
    setTableId(tableId);
    const isNotEmptyModel = Object.keys(selectionModel).length !== 0;
    store.dispatch(allocationsActions.setAllocationSelectionModel(selectionModel));
    if (isNotEmptyModel) {
      store.dispatch(userActions.setShowUserInfoWindow(true));
    }
  };


  const [occupiedTab, setOccupiedTab] = useState(
    new TabItemEntity(
      `${Strings.TABS_NAMES.OCCUPIED} (${allocations?.length})`, 
      TABLES.OCCUPIED,
      getOccupiedDataTable(onRowClick) 
    )
  );

  useEffect(() => {
    setOccupiedTab(
      new TabItemEntity(
        `${Strings.TABS_NAMES.OCCUPIED} (${allocations?.length})`, 
        TABLES.OCCUPIED,
        getOccupiedDataTable(onRowClick) 
      )
    );
  }, [allocations]);

  useEffect(() => {
    let updatedSelectedAllocation = allocations?.find(allocation => allocation.id === selectionModel?.id);
    if (updatedSelectedAllocation) {
      store.dispatch(allocationsActions.setAllocationSelectionModel(updatedSelectedAllocation));
    }
  }, [allocations, currentUsersSite]);

  tabs = [occupiedTab];

  const handleCloseEvent = () => {
    store.dispatch(userActions.setShowUserInfoWindow(false));
  };

  const handleModalOpen = () => {
    store.dispatch(
      commonActions.setSideModal({ modalContent: <AddAllocationsForm /> })
    );
  };

  return (
    <div className={classes.allocationsPage}>
      <Grid container spacing={4} className={classes.allocationsContainer}>
        <Grid xs={12} item className={classes.item}>
          <PageHeader
            icon={Icons.ALLOCATIONS2}
            pageTitle={Strings.TITLES.ALLOCATIONS_PAGE}
            // pageSecondTitle={Strings.TITLES.FREE_ALLOCATIONS}
            // pageSecondTitleValue={unoccupiedAllocations?.length}
            buttonText={Strings.PARKING_ALLOCATION}
            validRole={gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.COLLABORATOR}
            handleModalOpen={handleModalOpen}
          />
          {tabs && (
            <CustomTabs
              initialTab={`${Strings.TABS_NAMES.OCCUPIED} (${allocations?.length})`} 
              tabs={tabs}
              onTabChange={handleCloseEvent}
            ></CustomTabs>
          )}
        </Grid>
        {showUserInfoWindow && selectionModel && (
          <Divider orientation="vertical" flexItem></Divider>
        )}
        {showUserInfoWindow && selectionModel && (
          <Grid xs={5} item className={classes.item}>
            <AllocationInfo
              {...selectionModel}
              handleCloseEvent={handleCloseEvent}
              isSpaceNeeded={true}
              closeButton={true}
              tableId={tableId}
              validRole={
                gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.COLLABORATOR
              }
            ></AllocationInfo>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default AllocationsPage;
